import {PriceModel} from '../Price.model';
import {ModelContext} from '../../../types/app.types';
import {ConvertedMoney, ItemPriceBreakdown} from '@wix/auto_sdk_ecom_current-cart-v-2';
import {getBaseUnitPrice} from './LineItem.model';

export class BreakdownModel {
  public comparePrice?: PriceModel;
  public comparePriceByQuantity?: PriceModel;
  public basePrice?: PriceModel;
  public totalModifiersPrice?: PriceModel;

  constructor(params: BreakdownModel) {
    this.comparePrice = params.comparePrice;
    this.comparePriceByQuantity = params.comparePriceByQuantity;
    this.basePrice = params.basePrice;
    this.totalModifiersPrice = params.totalModifiersPrice;
  }

  public static fromCartV1({
    comparePrice,
    comparePriceByQuantity,
    basePrice,
    totalModifiersPrice,
  }: {
    comparePrice?: PriceModel;
    comparePriceByQuantity?: PriceModel;
    basePrice?: PriceModel;
    totalModifiersPrice?: PriceModel;
  }) {
    return new BreakdownModel({
      comparePrice,
      comparePriceByQuantity,
      basePrice,
      totalModifiersPrice,
    });
  }

  public static fromCartV2(
    breakdown: ItemPriceBreakdown,
    unitPrice: ConvertedMoney,
    quantity: number,
    modelContext: ModelContext
  ): BreakdownModel {
    const crossedOutPrice = getCrossedOutPrice(breakdown, unitPrice);
    const modeledCrossedOutPrice = crossedOutPrice ? PriceModel.fromCartV2(crossedOutPrice, modelContext) : undefined;
    const modeledTotalModifiersPrice = PriceModel.fromCartV2(breakdown.totalModifiersPrice, modelContext);
    const modeledUnitPrice = PriceModel.fromCartV2(unitPrice, modelContext);
    return new BreakdownModel({
      comparePrice: modeledCrossedOutPrice,
      comparePriceByQuantity: PriceModel.fromCartV2(
        crossedOutPriceByQuantity({modeledCrossedOutPrice, quantity, modelContext}),
        modelContext
      ),
      basePrice: PriceModel.fromCartV2(
        getBaseUnitPrice({modeledTotalModifiersPrice, modeledUnitPrice, modeledCrossedOutPrice, modelContext}),
        modelContext
      ),
      totalModifiersPrice: modeledTotalModifiersPrice,
    });
  }
}

function getCrossedOutPrice(breakdown: ItemPriceBreakdown, unitPrice: ConvertedMoney) {
  if (breakdown.salePrice?.convertedAmount !== unitPrice.convertedAmount) {
    return breakdown.salePrice;
  } else if (breakdown.fullPrice?.convertedAmount !== unitPrice.convertedAmount) {
    return breakdown.fullPrice;
  }
  return undefined;
}

function crossedOutPriceByQuantity({
  modeledCrossedOutPrice,
  quantity,
  modelContext,
}: {
  modeledCrossedOutPrice: PriceModel;
  quantity: number;
  modelContext: ModelContext;
}) {
  if (!modeledCrossedOutPrice) {
    return undefined;
  }
  return {
    convertedAmount: (modeledCrossedOutPrice.convertedAmount * quantity).toString(),
    formattedConvertedAmount: modelContext.formatAmount(modeledCrossedOutPrice.convertedAmount * quantity),
  };
}
